<div class="wrap-x flex-x flex-l flex-m feature-banner animation-long"
     [class.animation-reveal]="canAnimate()"
     [gsap]
     [gsapOff]="client.isCms || !component.animation"
     [scrollTrigger]="{ start: '50% bottom', end: '100% top', toggleClass: 'is-animate', once: true }">
    @for (item of component.section; track $index) {
    @if (hasBeforeColumn(item, $index)) {
    <div class="c-1"></div>
    }
    <div [ngClass]="getColumnClass(item, $index)">
        <href [link]="item.link"
              [hrefClass]="'block'">
            <div [ngClass]="getColumnInnerClass(item, $index)">
                <div class="overflow-hidden"
                     [ngClass]="item.ratio || 'ratio-2-3'">
                    @if (item.video_id && !item.image) {
                    <shell />
                    }
                    <!-- image -->
                    @if (item.image) {
                    <img class="z-2 animation-zoom-in animation-on-hover"
                         [dfImage]="item.image"
                         [priority]="component.cwvLoading === 'eager' || component.cwvPriority"
                         [ratio]="item.ratio || 'ratio-2-3'"
                         [alt]="item.title"
                         fill>
                    }
                    <!-- video -->
                    @if (item.video_id) {
                    <local-vimeo-player class="rf z-3 bg-col-w"
                                        [video-id]="item.video_id"
                                        [autoplay-in-viewport]="true"
                                        [background]="true" />
                    }
                </div>
                @switch (item.size) {
                @case ('small') {
                @switch (item.layout) {
                @case ('button') {
                <ng-container *ngTemplateOutlet="button; context: {$implicit: item}" />
                }
                @case ('quotation') {
                <div class="flex flex-column flex-middle center">
                    <i class="va-m m-t-8 m-t-4-m m-t-4-s fs-18 fs-16-m fs-16-s icon-quote"></i>
                    <div class="q1 p-b"
                         *iCms="'quote' of item">
                    </div>
                    <div class="c1 b-t p-l-2 p-r-2 p-t-3"
                         *iCms="'caption' of item">
                    </div>
                </div>
                }
                @case ('button_copy') {
                <div class="flex flex-column flex-middle">
                    <ng-container *ngTemplateOutlet="copy; context: {$implicit: item, line: 'first', class: 'p1'}" />
                    <ng-container *ngTemplateOutlet="copy; context: {$implicit: item, line: 'second', class: 'h1'}" />
                    <ng-container *ngTemplateOutlet="button; context: {$implicit: item}" />
                </div>
                }
                @case ('copy') {
                <div class="flex flex-column flex-middle">
                    <ng-container *ngTemplateOutlet="copy; context: {$implicit: item, line: 'first', class: 'p1'}" />
                    <ng-container *ngTemplateOutlet="copy; context: {$implicit: item, line: 'second', class: 'h1'}" />
                    <ng-container *ngTemplateOutlet="copy; context: {$implicit: item, line: 'third', class: 'h2'}" />
                </div>
                }
                }
                }
                @default {
                <ng-container *ngTemplateOutlet="button; context: {$implicit: item}" />
                }
                }
            </div>
        </href>
    </div>
    @if (hasAfterColumn(item, $index)) {
    <div class="c-1"></div>
    }
    }
</div>

<ng-template #button
             let-item>
    <div class="m-t-3 m-b-2">
        <button class="button-inline has-icon"
                type="button">
            <span *iCms="'button_label' of item"></span>
        </button>
    </div>
</ng-template>

<ng-template #copy
             let-item
             let-line="line"
             let-styleClass="class">
    <p class="m-t-4 m-t-2-m m-t-2-s"
       [ngClass]="styleClass"
       *iCms="'caption_' + line of item"></p>
</ng-template>